import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import de from './locales/de.json';

// Custom language detector that defaults to English unless in Europe
const europeanLanguageDetector = {
  name: 'europeanDetector',
  lookup() {
    // Check if user has already selected a language (stored in localStorage)
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang) {
      return storedLang;
    }

    // List of European country codes
    const europeanCountries = [
      'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 
      'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 
      'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'NO', 'CH', 
      'IS', 'LI', 'AL', 'AD', 'BA', 'BY', 'MD', 'MC', 'ME', 'MK', 
      'RS', 'SM', 'UA', 'VA'
    ];

    // Check timezone to detect European region
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const isEurope = timezone.includes('Europe/');

    // Check browser language for European locales
    const browserLang = navigator.language || navigator.userLanguage;
    const langCountryCode = browserLang.split('-')[1];
    const isEuropeanLocale = langCountryCode && europeanCountries.includes(langCountryCode.toUpperCase());

    // German-speaking countries get German
    const germanSpeakingCountries = ['DE', 'AT', 'CH', 'LI'];
    const isGermanSpeaking = langCountryCode && germanSpeakingCountries.includes(langCountryCode.toUpperCase());

    // Return German if in Europe AND (timezone is Europe OR locale is European OR German-speaking)
    if (isGermanSpeaking || (isEurope && isEuropeanLocale)) {
      return 'de';
    }

    // Default to English for everyone else
    return 'en';
  },
  cacheUserLanguage(lng) {
    localStorage.setItem('i18nextLng', lng);
  }
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(europeanLanguageDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de }
    },
    fallbackLng: 'en',
    lng: undefined, // Let detector decide
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['europeanDetector'],
      caches: ['localStorage']
    }
  });

export default i18n;
